import { createActor } from 'xstate';

import { BaseChartStore } from 'features/base-chart-store';
import { SelectOption, PatientSatisfactionResponse } from 'types';

import { PatientSatisfaction } from '../patient-satisfaction.model';
import { PatientSatisfactionSerializer } from '../serializer';

export class PatientSatisfactionStore extends BaseChartStore<
  PatientSatisfaction,
  PatientSatisfactionResponse
> {
  constructor(private serializer: PatientSatisfactionSerializer) {
    super('Patient Satisfaction Machine');
    // extend base chart machine if necessary
    this.service = createActor(this.machine);
    this.service.subscribe((state) => {
      this.current = state;
    });
    this.service.start();
  }

  protected async doFetch(
    therapists: Array<SelectOption<string>>,
    partnerId: string | undefined,
    partners: Array<SelectOption<string>>,
    clinics: Array<SelectOption<string>>,
    time: string,
    signal?: AbortSignal,
  ) {
    const jsonResponse = await this.load(
      'patient_satisfaction',
      {
        therapists,
        partnerId,
        partners,
        clinics,
        time,
      },
      signal,
    );

    return this.serializer.deserialize(jsonResponse);
  }
}
